var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(-370 -133)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(370 133)",
    fill: "#18beb3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M162.412,113.677a5.948,5.948,0,1,0-6.009,0,9.207,9.207,0,0,0-7,8.618c0,1.61,2.377,2.028,3.273,2.185a35.866,35.866,0,0,0,5.782.4c1.212,0,3.168-.06,5.02-.23a.727.727,0,0,0-.133-1.449c-1.8.165-3.708.224-4.888.224a34.431,34.431,0,0,1-5.532-.377c-1.888-.332-2.067-.747-2.069-.752,0-4.18,3.833-7.581,8.545-7.581s8.545,3.4,8.545,7.581a.727.727,0,0,0,1.455,0A9.206,9.206,0,0,0,162.412,113.677Zm-7.5-5.13a4.493,4.493,0,1,1,4.493,4.493A4.5,4.5,0,0,1,154.914,108.546Z",
    transform: "translate(231.799 41.401)",
    fill: "#18beb3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.68354236ef9a7daee3fcb0a8a1bdc502.svg";
export { ForwardRef as ReactComponent };